import { render, staticRenderFns } from "./AmDropdownItem.vue?vue&type=template&id=600be80c&scoped=true&"
import script from "./AmDropdownItem.vue?vue&type=script&lang=js&"
export * from "./AmDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600be80c",
  null
  
)

export default component.exports